import { NEW_USER} from "../actionTypes";
import { addUser } from "../../../api/userManagement/newUser.service";

const request = () => ({ type: NEW_USER.REQUEST });
const failure = (error) => ({ type: NEW_USER.FAILURE, error });
const success = (data) => ({ type: NEW_USER.SUCCESS,data});



export const createUser= (payload) => {
  return (dispatch, getState) => {
    dispatch(request());
    return addUser(payload)
      .then((res) => {
        dispatch(success(res));
        return Promise.resolve({res:res,status:true});
      })
      .catch((error) => {
        dispatch(failure(error?.message));
        return Promise.resolve({error:error?.message,status:false});
      });
  };
};
